import type { FC } from "react";
import Stack, { type StackProps } from "../Stack";

const InlineStack: FC<StackProps> = ({ style, ...props }) => (
  <Stack style={{ gridAutoFlow: "column", ...style }} {...props} />
);

export default InlineStack;
